import { JSX } from "react";
import { useAppSelector } from "../../../app/hooks";

export const LeaveInformationContentHeader = (): JSX.Element => {
    const { personInfo } = useAppSelector((state) => state.root);

    return (
        <div className={"p-leave-information__content__header"}>
            <p>
                <span>{personInfo?.choice},</span> complete your vote
            </p>
            <h1>Leave your details and you could win the new SPRSO</h1>
        </div>
    );
};
